import { Pipe, PipeTransform, SecurityContext } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { TimerFormat } from '../../../extension-components/delivery-countdown-timer/components/delivery-countdown-timer/models';

@Pipe({
  name: 'deliveryCountdownTimerDisplayText',
  standalone: false,
})
export class DeliveryCountdownTimerDisplayTextPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}

  transform(template: any): string {
    const text = template?.appearance?.displayText || '';
    const timeDisplay = this.getTimeRemainingDisplay(template);

    // Replace placeholders with example values
    const processedText = text
      .replace(/{countdown}/g, timeDisplay)
      .replace(/{shipping_method}/g, 'Express Shipping')
      .replace(/{cutoff_time}/g, '4:59:00 PM')
      // Legacy placeholders for backward compatibility
      .replace(/{time_remaining}/g, timeDisplay)
      .replace(/{cut_off_timer\.hh\.mm\.ss}/g, timeDisplay)
      .replace(/{cut_off_timer\.hh\.mm}/g, '02:45')
      .replace(/{cut_off_timer\.compact}/g, '2h 45m');

    // Sanitize HTML to prevent XSS - preserves class attributes for SCSS styling
    return this.sanitizer.sanitize(SecurityContext.HTML, processedText) || '';
  }

  private getTimeRemainingDisplay(template: any): string {
    const format = template?.appearance?.timerFormat || TimerFormat.DIGITAL;

    if (format === TimerFormat.DIGITAL) {
      // Digital format: HH:MM:SS
      return '02:45:30';
    } else {
      // Compact format: "2h 45m 30s"
      return '2h 45m';
    }
  }
}
